import virtualvisit from '../_03_organisms/virtualvisit';
import calendly from '../_02_molecules/calendly';
import updateContact from './offer/contact';
import scheduleContact from './offer/contact-schedule';
import validateSellerOnboardingForm from '../_03_organisms/seller-onboarding';

/**
 * Init Vues, and check if el exist,
 * to avoid warnings when el is not present
 */
export default function () {
  // init virtualvisit
  if (document.querySelector('.virtualvisit') !== null) {
    virtualvisit();
  }
  if (document.querySelector('.rdv') !== null) {
    calendly();
  }

  if (document.querySelector('.contact-completion') !== null) {
    updateContact();
  }

  if (document.querySelector('.contact-schedule') !== null) {
    scheduleContact();
  }

  if (document.getElementById('seller-onboarding') !== null) {
    validateSellerOnboardingForm();
  }
}
